import RobotOutlineSvg from '@mdi/svg/svg/robot-outline.svg';
import AmazonBedrockConverseSvg from "../../images/logos/bedrock.svg";
import AnthropicSvg from "../../images/logos/anthropic.svg";
import AzureAISvg from "../../images/logos/azure.svg";
import CerebrasSvg from "../../images/logos/cerebras.svg";
import DeepSeekSvg from "../../images/logos/deepseek.svg";
import GoogleGeminiSvg from "../../images/logos/google-gemini.svg";
import GroqSvg from "../../images/logos/groq.svg";
import MistralAISvg from "../../images/logos/mistral.svg";
import NVIDIASvg from "../../images/logos/nvidia.svg";
import OllamaSvg from "../../images/logos/ollama.svg";
import OpenAISvg from "../../images/logos/openai.svg";
import PerplexitySvg from "../../images/logos/perplexity.svg";

export const getProviderLogo = provider => aiProviders[provider]?.logo || RobotOutlineSvg;

export const aiProviders = {
    AmazonBedrockConverse: {
        name: 'Amazon Bedrock Converse',
        logo: AmazonBedrockConverseSvg
    },
    AnthropicClaude: {
        name: 'Anthropic Claude',
        logo: AnthropicSvg
    },
    AzureOpenAI: {
        name: 'Azure OpenAI',
        logo: AzureAISvg
    },
    Cerebras: {
        name: 'Cerebras',
        logo: CerebrasSvg
    },
    DeepSeek: {
        name: 'DeepSeek (OpenAI-proxy)',
        logo: DeepSeekSvg
    },
    GoogleGemini: {
        name: 'Google Gemini',
        logo: GoogleGeminiSvg
    },
    Groq: {
        name: 'Groq',
        logo: GroqSvg
    },
    MistralAI: {
        name: 'Mistral AI',
        logo: MistralAISvg
    },
    NVIDIA: {
        name: 'NVIDIA (OpenAI-proxy)',
        logo: NVIDIASvg
    },
    Ollama: {
        name: 'Ollama',
        logo: OllamaSvg
    },
    OpenAI: {
        name: 'OpenAI',
        logo: OpenAISvg
    },
    Perplexity: {
        name: 'Perplexity (OpenAI-proxy)',
        logo: PerplexitySvg
    }
}